import { render, staticRenderFns } from "./providerSetup.vue?vue&type=template&id=0d6660de&"
import script from "./providerSetup.vue?vue&type=script&lang=js&"
export * from "./providerSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports